module.exports = __webpack_public_path__ + "static/media/love-pink.be9592b3.svg";